import { useUserStore } from '@bv/stores';

import { useCallCenterStore } from '@/stores/call-center/call-center.store';
import { CallType } from '@/types/call-center/call-center.types';

export default function addInboundCall({ data }: { data: CallType }): void {
  const detailsStore = useUserStore();
  const callCenterStore = useCallCenterStore();

  if (String(detailsStore.userDetails?.id) === String(data.agent.id) && data.direction === 'inbound') {
    callCenterStore.setCurrentCall(data);
  }
}
